import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failurelistdaycalculation,
  successlistdaycalculation,
} from "./ListdaycalculationSlice";

// list
const ListdaycalculationApi = () => {
  return api.get("/api/exam/exam-date/day-calculation");
};

export function* ListdaycalculationCall() {
  try {
    const response: AxiosResponse = yield call(ListdaycalculationApi);
    yield put(successlistdaycalculation(response.data));
  } catch (error) {
    yield put(failurelistdaycalculation(error));
  }
}
